import React from 'react'
import Contact from '../component/Contact'
import Footer from '../component/Footer'
import Hero from '../component/Hero'
import Navbar from '../component/Navbar'

const ContactRoute = () => {
  return (
    <>
    <Navbar/>
    <Hero/>
    <Contact/>
    <Footer/>
    </>
  )
}

export default ContactRoute